
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{data?.title}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{data?.message}}
    </div>
    <div class="modal-footer">

      <button *ngIf="data?.btCancel" type="button" class="btn btn-default" (click)="cancel()" >Cancel</button>
      <button type="button" [ngClass]="data?.dError ? 'btn btn-default btn-cons' : 'btn btn-success'" class="" (click)="clickOk()" >ok</button>
    </div>
  </div>


